module.exports = __webpack_public_path__ + "img/team_dillingen.f5eead97.png";